import { PAIR_OPTION } from 'enums';

import { PairOption } from './types';

export const pair_option: Record<PAIR_OPTION, string> = {
  [PAIR_OPTION.RUN_PAIR]: 'Run Pair',
  [PAIR_OPTION.PAUSE_PAIR]: 'Pause Pair',
  [PAIR_OPTION.INITIALIZE_CANDLE_WORKER]: 'Initialize Candle Workers',
  [PAIR_OPTION.RUN_CANDLE_WORKER]: 'Run Candle Workers',
  [PAIR_OPTION.PAUSE_CANDLE_WORKER]: 'Pause Candle Workers',
  [PAIR_OPTION.DELETE_CANDLE_WORKER]: 'Delete Candle Workers',
  [PAIR_OPTION.RESET_VALIDATION]: 'Reset Validations',
};

export const pair_message: Record<PAIR_OPTION, string> = {
  [PAIR_OPTION.RUN_PAIR]:
    'Running activates market collection, candle workers and validations to process.',
  [PAIR_OPTION.PAUSE_PAIR]:
    'Pausing stops market collection, candle workers and validations to process.',
  [PAIR_OPTION.INITIALIZE_CANDLE_WORKER]:
    'Initializing overrides existing candles from the date selected.',
  [PAIR_OPTION.RUN_CANDLE_WORKER]: 'Running processes existing candle workers that are Paused.',
  [PAIR_OPTION.PAUSE_CANDLE_WORKER]: 'Pausing stops existing candle workers that are Initialized.',
  [PAIR_OPTION.DELETE_CANDLE_WORKER]: 'Deleting removes all candle workers that are Initialized.',
  [PAIR_OPTION.RESET_VALIDATION]: 'Reset validations below the 95% accuracy threshold.',
};

export const pair_options: PairOption[] = [
  {
    name: pair_option[PAIR_OPTION.RUN_PAIR],
    message: pair_message[PAIR_OPTION.RUN_PAIR],
    id: PAIR_OPTION.RUN_PAIR,
    uuid: PAIR_OPTION.RUN_PAIR,
  },
  {
    name: pair_option[PAIR_OPTION.PAUSE_PAIR],
    message: pair_message[PAIR_OPTION.PAUSE_PAIR],
    id: PAIR_OPTION.PAUSE_PAIR,
    uuid: PAIR_OPTION.PAUSE_PAIR,
  },
  {
    name: pair_option[PAIR_OPTION.INITIALIZE_CANDLE_WORKER],
    message: pair_message[PAIR_OPTION.INITIALIZE_CANDLE_WORKER],
    id: PAIR_OPTION.INITIALIZE_CANDLE_WORKER,
    uuid: PAIR_OPTION.INITIALIZE_CANDLE_WORKER,
  },
  {
    name: pair_option[PAIR_OPTION.RUN_CANDLE_WORKER],
    message: pair_message[PAIR_OPTION.RUN_CANDLE_WORKER],
    id: PAIR_OPTION.RUN_CANDLE_WORKER,
    uuid: PAIR_OPTION.RUN_CANDLE_WORKER,
  },
  {
    name: pair_option[PAIR_OPTION.PAUSE_CANDLE_WORKER],
    message: pair_message[PAIR_OPTION.PAUSE_CANDLE_WORKER],
    id: PAIR_OPTION.PAUSE_CANDLE_WORKER,
    uuid: PAIR_OPTION.PAUSE_CANDLE_WORKER,
  },
  {
    name: pair_option[PAIR_OPTION.DELETE_CANDLE_WORKER],
    message: pair_message[PAIR_OPTION.DELETE_CANDLE_WORKER],
    id: PAIR_OPTION.DELETE_CANDLE_WORKER,
    uuid: PAIR_OPTION.DELETE_CANDLE_WORKER,
  },
  {
    name: pair_option[PAIR_OPTION.RESET_VALIDATION],
    message: pair_message[PAIR_OPTION.RESET_VALIDATION],
    id: PAIR_OPTION.RESET_VALIDATION,
    uuid: PAIR_OPTION.RESET_VALIDATION,
  },
];
